import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {COURSE} from "../../../../tenant/Config/ApiUrl";

const state =  {
    course: {},
}

const getters = {
    getCourseDetails: state => {
        return state.course
    }
};

const actions = {
    getCourseDetails({commit, state}, courseId){
        commit('SET_LOADER', true)
        axiosGet(`${COURSE}/${courseId}`).then(({ data }) =>{
            commit('COURSE_DETAILS_DATA', data)
        }).finally(()=> commit('SET_LOADER', false))
    },
}

const mutations = {
    COURSE_DETAILS_DATA(state, data){
        state.course = data;
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}
